package com.karyadina.freesource.repository

import com.karyadina.freesource.data.FreeSourceData
import com.karyadina.freesource.model.FreeSource
import kotlinx.serialization.json.Json

class FreeSourceRepository {
    
    private val jsonSerializer = Json { ignoreUnknownKeys = true }
    
    // Lazy initialization so it only parses when first accessed
    val allSources: List<FreeSource> by lazy {
        try {
            jsonSerializer.decodeFromString(FreeSourceData.json)
        } catch (e: Exception) {
            emptyList()
        }
    }
    
    // We get English categories to maintain a stable grouping key
    fun getCategories(): List<String> {
        return allSources.map { it.category.en }.distinct().sorted()
    }
    
    fun searchAndFilter(query: String = "", categoryEn: String? = null, isHindi: Boolean = false): List<FreeSource> {
        return allSources.filter { source ->
            val matchesQuery = if (query.isBlank()) true else {
                source.title.getText(isHindi).contains(query, ignoreCase = true) ||
                source.description.getText(isHindi).contains(query, ignoreCase = true) ||
                source.tags.any { it.contains(query, ignoreCase = true) }
            }
            
            val matchesCategory = if (categoryEn.isNullOrBlank()) true else {
                source.category.en == categoryEn
            }
            
            matchesQuery && matchesCategory
        }
    }
}
